import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { catchError, finalize, map } from 'rxjs/operators';
import { LoadingController, ToastController } from '@ionic/angular';
import { Router } from '@angular/router';
import { ToastService } from '../services/toast.service';
import { EventService } from '../services/event.service';



@Injectable({
  providedIn: 'root'
})
export class TokenInterceptor implements HttpInterceptor {
  private count_request = 0;

  constructor(
    private authService: AuthService,
    private router: Router,
    private loadingController: LoadingController,
    private toastService: ToastService,
    private eventService: EventService
   ) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = this.authService.getToken();
    const lg = /login/gi;
    const qb =/public/gi;

   
    if (req.url.search(lg)===-1){
      if (req.url.search(qb)===-1){ 
        if (token){
          req = req.clone({
            setHeaders: {
              //           'Api-Token': token,
              'Authorization': 'Bearer ' + token
              //           'X-Requested-With': 'XMLHttpRequest',
            }
          })
        }
      }
    }
   
    if (!this.count_request) {
      this.presentLoading();
    }
    this.count_request++;



    return next.handle(req).pipe(
      finalize(() => {
        this.count_request--;
        if (!this.count_request) {
          this.loadingController.getTop().then(v=>{
            if (v!=undefined){
              this.loadingController.dismiss();
            }})
        }
        if (this.count_request===0){
          setTimeout(() => {
            this.loadingController.getTop().then(v=>{
              if (v!=undefined){
                this.loadingController.dismiss();
              }})
          }, 5000);
        }
        
        
      })).pipe(

      catchError(error => {
        if (error.status===401){
          if (this.router.url!='/login'){
            this.toastService.presentToastErrorWithOption(error.error.message,()=>{
              this.authService.logOut();
              this.router.navigate(['/login']);
            })
           
          }
        }
        this.eventService.executeCallBack(error);
        this.eventService.clearCallBack();
        throw new Error('');
      })
    )
  }
  
  async presentLoading() {
    const loading = await this.loadingController.create({
      message: 'Please wait...',
      spinner: 'crescent'
    });
    await loading.present();
  }



}
